import reducer from './reducers';
import * as userActions from './actions';

export { userActions };
export default reducer;
